import { Map as ImmutableMap, List, Record, RecordOf } from 'immutable';

export interface RootUiData {
  type: string;
  id: string;
  visible: boolean;
  allowNesting: boolean;
  props: ImmutableMap<string, any>;
  createdAt?: number;
}
export const mkRootUiData = Record<RootUiData>({
  type: 'UNKNOWN',
  id: '0',
  visible: true,
  allowNesting: true,
  props: ImmutableMap(),
  createdAt: Date.now(),
});

export interface RootUiStore {
  activeModals: List<RecordOf<RootUiData>>;
  queuedModals: List<RecordOf<RootUiData>>;
}

export const mkRootUiStore = Record<RootUiStore>({
  activeModals: List(),
  queuedModals: List(),
});

export const REDUCER_KEY = 'rootUiStore';
declare module 'app-components/utils/redux-store/rootState' {
  export default interface RootState {
    [REDUCER_KEY]: RecordOf<RootUiStore>;
  }
}
